import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { CubejsClient } from '@cubejs-client/ngx';
import Aura from '@primeuix/themes/aura-compat';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { appRoutes } from './app.routes';
import { provideAuthCore } from './core/auth/auth.provider';
import { AuthenCubeJsService } from './core/auth/authen-cube-js.service';
import { provideCubeJsCore } from './core/cubeJs/cube-js.provider';
import { provideHttpCore } from './core/http/http.provider';
import { provideLoggerCore } from './core/logger/logger.provider';
import { providePathLocationStrategy } from './core/mobile/path-preserve-mobile-query-location-strategy.service';
import { provideSwaggerCore } from './core/swagger/swagger.provider';
import { provideTranslateCore } from './core/translate/translate.provider';

registerLocaleData(localeFr, 'fr');

const cubejsClientFactory = (authService: AuthenCubeJsService) => {
  return new CubejsClient(authService.config$);
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    provideNoopAnimations(),
    provideAuthCore(),
    provideHttpCore(),
    provideTranslateCore(),
    provideSwaggerCore(),
    provideCubeJsCore(),
    provideLoggerCore(),
    providePathLocationStrategy(),
    AuthenCubeJsService,
    {
      provide: CubejsClient,
      useFactory: cubejsClientFactory,
      deps: [AuthenCubeJsService],
    },
    importProvidersFrom(MatDialogModule, MatSnackBarModule, DialogService, ConfirmationService, MessageService),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'app-styles, primeng-overrides, primeng',
          },
        },
      },
    }),
  ],
};
